import React from "react";
import { observer } from "mobx-react";
import { ReportTypeViewStore } from "../../store";
import { ReportTypeViewForm } from "./ReportTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ReportTypeViewProps = {
  reportTypeViewStore: ReportTypeViewStore;
};

export const ReportTypeView: React.FC<ReportTypeViewProps> = observer(
  ({ reportTypeViewStore }) => {
    return (
      <div>
        <ReportTypeViewForm
          name={reportTypeViewStore.nameValue}
          description={reportTypeViewStore.descriptionValue}
          onPrint={(handlePrint: () => void) =>
            reportTypeViewStore.printReportType(handlePrint)
          }
          onCancel={() => reportTypeViewStore.cancelReportType()}
          onEdit={
            reportTypeViewStore.isEditEnabled
              ? () => reportTypeViewStore.editReportType()
              : undefined
          }
        />
        <ErrorDialog
          open={reportTypeViewStore.errorDialogOpened}
          title={reportTypeViewStore.errorTitle}
          description={reportTypeViewStore.errorDescription}
          onClose={() => reportTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
